import bStrg, { parsedToken } from "./storageHelper";
import LoginService, { parseQuery } from "./login/loginService";
import { handleSessionTimeout } from "./sessionTimeout";
import { getTolocalStorage } from "../Containers/Constants/commenFeatures";

interface callReq {
  url: string;
  method: string;
  body?: {};
  authType?:
    | "bearer"
    | "authtoken"
    | "noToken"
    | "access_token"
    | "SPK"
    | "encryption";
  appidkey?: string;
  appid?: string;
  source?: string;
  headers?: any;
  sourcetoken?: string;
  abortControllerRef?: any;
}
export const apiService = async (
  req: callReq,
  callback: CallableFunction,
  abortController?: CallableFunction
) => {
  const Abort_Controller = new AbortController();
  let pToken: any = parsedToken();
  var params: any = {
    method: req.method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (req.authType) {
    switch (req.authType) {
      case "bearer":
        params.headers.authorization = LoginService.jwtToken
          ? `Bearer ${LoginService.jwtToken}`
          : `Bearer ${bStrg("local").jwt_token}`;
        break;
      case "authtoken":
        params.headers.authorization =
          LoginService.authorization || (pToken ? pToken.auth_token : "");
        break;

      case "access_token":
        params.headers.access_token = await getTolocalStorage("access_token");
        break;
      case "SPK":
        params.headers.SPK = "serverPublicKey";
        break;
      case "encryption":
        params.headers.CPK = req.headers ? req.headers.CPK : "";
        params.headers.SEPRK = req.headers ? req.headers.SEPRK : "";
        break;
      default:
        break;
    }
  }
  if (req.appidkey) {
    params.headers["appidkey"] = req.appidkey;
  }
  if (req.appid) {
    params.headers["appid"] = req.appidkey;
  }

  if (window.location.search) {
    const queryString = parseQuery(window.location.search);
    if (queryString.api_key) {
      params.headers.Source = sessionStorage.getItem("source");
      let sourcetoken = sessionStorage.getItem("sourceToken");
      if (sourcetoken !== null || sourcetoken !== undefined) {
        params.headers.SourceToken = sourcetoken;
      }
    }
  }

  if (
    req.method === "POST" ||
    req.method === "PUT" ||
    req.method === "DELETE"
  ) {
    params["body"] = JSON.stringify(req.body);
  }
  //Cancelling Fetch Requests
  if (abortController) {
    abortController(Abort_Controller);
    params.signal = Abort_Controller.signal;
  }
  try {
    const resp = await fetch(req.url, params);
    const newResp = await resp;

    newResp
      .json()
      .then((res) => {
        handleSessionTimeout(newResp, res);
        callback(res, newResp);
      })
      .catch((res) => {
        handleSessionTimeout(newResp, res);
        callback(undefined, newResp);
      });
  } catch (err) {
    // all errors will be captured here for anything in the try block
    callback &&
      callback({
        error: "500",
        errMsg: err || "something went wrong please try again later",
      });
  }
};
